module.exports = __webpack_public_path__ + "static/media/nota-duplicata.26ab5191.svg";